export default {
  title: {
    en: 'Add AZUR token to your wallet',
  },
  button: {
    en: 'Add AZUR',
  },
}
